import React from 'react'
import { Icon } from '@amzn/storm-ui'
import { PlayPauseContainer, PlayPauseButton } from './style'
import { useLaunchModalContext } from '../../../../contexts/LaunchModalContext'

const CarouselPlayButton: React.VFC<{ ariaLabelsPlay: string; ariaLabelsPause: string }> = ({ ariaLabelsPlay, ariaLabelsPause }) => {
  const { isPlaying, dataTaktId, stopFn, playFn } = useLaunchModalContext()

  //the span wrapper is to distinguish between play and pauseIcon so the react components switch onClick, if deleted, it won't switch
  const playIcon = (
    <PlayPauseButton onClick={stopFn}>
      <span>
        <Icon type={'pause-circle'} size="lg" aria-label={ariaLabelsPlay} data-takt-id={`${dataTaktId}_play-button`} />
      </span>
    </PlayPauseButton>
  )
  const pauseIcon = (
    <PlayPauseButton onClick={playFn}>
      <Icon type={'play-circle'} size="lg" aria-label={ariaLabelsPause} data-takt-id={`${dataTaktId}_pauce-button`} />
    </PlayPauseButton>
  )

  return <PlayPauseContainer>{isPlaying ? playIcon : pauseIcon}</PlayPauseContainer>
}

export default CarouselPlayButton
